/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Hesshochschuldepartment2Inputs */

const en__field_hesshochschuldepartment2 = /** @type {(inputs: _Field_Hesshochschuldepartment2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Department`)
};

const de__field_hesshochschuldepartment2 = /** @type {(inputs: _Field_Hesshochschuldepartment2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fachbereich`)
};

/**
* | output |
* | --- |
* | "Department" |
*
* @param {_Field_Hesshochschuldepartment2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_hesshochschuldepartment2 = /** @type {((inputs?: _Field_Hesshochschuldepartment2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Hesshochschuldepartment2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_hesshochschuldepartment2(inputs)
	return de__field_hesshochschuldepartment2(inputs)
});
export { _field_hesshochschuldepartment2 as "_field_hessHochschulDepartment" }